import { createSlice } from "@reduxjs/toolkit";
import { deleteProductPhotoThunk, fetchProductPhotosThunk } from "./productPhotosThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    deleting: false,
    hasMore: true,
    error: null,
    page: 1
};

export const productPhotosSlice = createSlice({
    name: "product-photos",
    initialState,
    reducers: {
        removeItem: (state, action) => {
            const photoUrl = action.payload;
            state.items = state.items.filter((e) => e.url !== photoUrl);
            state.total = state.total - 1;
        },
        removeItems: (state, action) => {
            const photoUrls = action.payload;
            state.items = state.items.filter((e) => !photoUrls.includes(e.url));
            state.total = state.total - photoUrls.length;
        },
        reset: (state) => {
            state.items = [];
            state.total = 0;
            state.totalPages = 0;
            state.page = 1;
            state.hasMore = true;
            state.error = null;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setItems: (state, action) => {
            const newItems = action.payload;
            state.items = [...state.items, ...newItems];
            state.total += newItems.length;
            state.hasMore = newItems.length > 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductPhotosThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductPhotosThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                state.items = data.content;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
            })
            .addCase(fetchProductPhotosThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            //delete
            .addCase(deleteProductPhotoThunk.pending, (state) => {
                state.deleting = true;
                state.error = null;
            })
            .addCase(deleteProductPhotoThunk.fulfilled, (state, action) => {
                state.deleting = false;
                const photoUrl = action.payload;
                state.items = state.items.filter((e) => e.url !== photoUrl);
                state.total -= 1;
            })
            .addCase(deleteProductPhotoThunk.rejected, (state, action) => {
                state.deleting = false;
                state.error = action.payload;
            });
    }
});

export const { reset, removeItem, removeItems, setPage, setItems } =
    productPhotosSlice.actions;
export default productPhotosSlice.reducer;
